export function getFormattedRoleName(role?: string): string | undefined {
    if (!role) {
        return role;
    }

    return role.replace('Pilot.', '').replace('.Team', '').replaceAll('.', ' ');
}
